module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('i', [_vm._v("For Martin Gardner")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("STERLING and the distinctive Sterling logo are registered trademarks of"), _c('br'), _vm._v("Sterling Publishing Co., Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Pickover, Clifford A."), _c('br'), _vm._v("  The math book / Clifford A. Pickover."), _c('br'), _vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN 978-1-4027-5796-9"), _c('br'), _vm._v("1. Mathematics–History. I. Title."), _c('br'), _vm._v("QA21.P53 2009"), _c('br'), _vm._v("510.9–dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright4"
  }, [_vm._v("2008043214")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Published by Sterling Publishing Co., Inc."), _c('br'), _vm._v("387 Park Avenue South, New York, NY 10016"), _c('br'), _vm._v("© 2009 by Clifford A. Pickover")]), _vm._v(" "), _c('p', {
    staticClass: "copyright5"
  }, [_c('i', [_vm._v("All rights reserved")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Sterling ISBN 978-1-4027-9749-1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright6"
  }, [_vm._v("For information about custom editions, special sales, premium and"), _c('br'), _vm._v("corporate purchases, please contact Sterling Special Sales Department at 800–805–5489 or specialsales@sterlingpublishing.com.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b8f595","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/crt.vue
// module id = 69
// module chunks = 0